<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>数据备份与恢复</span>
          <el-button type="primary" @click="handleBackup" :loading="backing" style="float: right">手动备份</el-button>
        </div>
      </template>
      <el-alert title="系统会自动进行每日备份，您也可以手动创建备份。恢复操作将回滚数据库到备份时的状态，请谨慎操作。" type="info" show-icon :closable="false" class="mb-4"></el-alert>
      <el-table :data="backupList" style="width: 100%" stripe>
        <el-table-column prop="backupName" label="备份名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="backupType" label="备份类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.backupType === 'auto' ? 'info' : 'primary'" size="small">
              {{ scope.row.backupType === 'auto' ? '自动备份' : '手动备份' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="backupSize" label="大小" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" width="100"></el-table-column>
        <el-table-column prop="createTime" label="备份时间" width="170"></el-table-column>
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" type="warning" size="small" @click="handleRestore(scope.row)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { backupApi } from '../api/api'

export default {
  data() {
    return {
      backupList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      backing: false
    }
  },
  mounted() {
    this.getBackupList()
  },
  methods: {
    getBackupList() {
      backupApi.getBackupPage(this.currentPage, this.pageSize).then(res => {
        this.backupList = res.data.records || []
        this.total = res.data.total || 0
      })
    },
    handleSizeChange(size) { this.pageSize = size; this.getBackupList() },
    handleCurrentChange(page) { this.currentPage = page; this.getBackupList() },
    handleBackup() {
      const userStr = sessionStorage.getItem('user')
      const operator = userStr ? JSON.parse(userStr).name || 'admin' : 'admin'
      this.backing = true
      backupApi.createBackup(operator).then(res => {
        if (res.data.success) {
          this.$message.success('备份创建成功')
          this.getBackupList()
        } else {
          this.$message.error(res.data.message || '备份失败')
        }
      }).finally(() => { this.backing = false })
    },
    handleRestore(row) {
      this.$confirm(`确定要恢复到备份 "${row.backupName}" 的状态吗？此操作不可逆！`, '提示', {
        confirmButtonText: '确定恢复',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        backupApi.restoreBackup(row.id).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('恢复成功')
          } else {
            this.$message.error(res.data.message || '恢复失败')
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.clearfix { display: flex; align-items: center; justify-content: space-between; }
</style>
